var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { buildNutritionRequestBody, getDefaultCustomizeOptions, getRecipeNutrition, } from "../../../../Shared/components/CustomizeModal/CustomizeModal-utils";
import { createKey } from "../../../../Shared/utils/createKey";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { getMustReplaceIngredients } from "../../../hooks/RecipeSelection/recipeSelectionUtils";
import { HandleCustomizeSubmit } from "./RecipeModule-utils";
// Create a new recipe assignment.
export const createRecipeAssignment = ({ recipe, currentAssignmentQuantity, programMealId, selectedDay, recipeAssignment, }) => {
    var _a, _b, _c;
    return {
        RecipeId: recipe.RecipeId,
        RecipeName: recipe.RecipeName,
        Quantity: currentAssignmentQuantity,
        ProgramMealId: programMealId,
        Date: moment(selectedDay),
        RecipeShortName: recipe.RecipeShortName,
        SelectedIngredientOptions: (_a = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.SelectedIngredientOptions) !== null && _a !== void 0 ? _a : [],
        RecipePrice: (_b = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _b !== void 0 ? _b : 0,
        RecipeAssignmentPrice: (_c = recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.RecipeAssignmentPrice) !== null && _c !== void 0 ? _c : 0,
        IsAutomaticSelection: false,
        CompatibilityType: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.CompatibilityType,
        AutomaticReplacements: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.AutomaticReplacements,
        Skips: recipeAssignment === null || recipeAssignment === void 0 ? void 0 : recipeAssignment.Skips,
        AssignmentId: createKey(),
    };
};
/**
 * Updates the meals in the cart based on the provided currentMeal.
 *
 * @param cartMeals - The list of meals in the cart.
 * @param currentMeal - The meal to update in the cart.
 * @returns The updated list of meals with only meals that have a quantity greater than 0.
 */
const updateCartMeals = (cartMeals, currentMeal) => {
    return cartMeals
        .map((meal) => meal.ProgramMealId === currentMeal.ProgramMealId &&
        moment(meal.MealDate).isSame(moment(currentMeal.MealDate), "day")
        ? currentMeal
        : meal)
        .filter((meal) => meal.Quantity > 0);
};
// Toggle recipe selection based on the given cases and conditions.
export const toggleRecipeSelection = (singleRecipeSelectLimit, assignToExistingMeals, addMeals, cartMeals, program, modelDeliveryDays, selectedDay, recipe, programMealId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const recipeName = recipe.RecipeName;
    const recipeId = recipe.RecipeId;
    let disableAddButton = false;
    let currentRecipeAssignment = undefined;
    let currentAssignmentQuantity = 0;
    // Determine if the recipe is already assigned to the meal and extract the assignment.
    const recipeAssignment = recipe.Assignments.find((assignment) => assignment.ProgramMealId === programMealId && moment(assignment.Date).isSame(moment(selectedDay), "day"));
    // Determine if the meal already exists in the cart and extract the meal.
    const currentMeal = cartMeals.find((meal) => moment(meal.MealDate).isSame(moment(selectedDay), "day") && meal.ProgramMealId === programMealId);
    // Extract meal price for existing meal.
    let mealPrice = (_a = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.Price) !== null && _a !== void 0 ? _a : 0;
    // Extract maxRecipeQuantity for existing meal.
    const maxRecipeQuantity = (_b = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.Quantity) !== null && _b !== void 0 ? _b : 0;
    // Prioritize assignToExistingMeals if both addMeals and assignToExistingMeals are true.
    // This means, however, that if the user cannot assign meals, and there are no default meals,
    // the user will not be able to make any selections.
    if (addMeals && assignToExistingMeals) {
        addMeals = false;
    }
    //* CASE 1: A meal exists (currentMeal is truthy) and "addMeals" is false.
    // - Handle recipe assignments for the existing meal.
    if (!!currentMeal && !addMeals) {
        // Ensure RecipeAssignments is initialized to prevent undefined access.
        currentMeal.RecipeAssignments = currentMeal.RecipeAssignments || [];
        // Check if the recipe is already selected.
        const recipeAlreadySelected = (_c = currentMeal.RecipeAssignments) === null || _c === void 0 ? void 0 : _c.some((assignment) => assignment.RecipeId === recipeId);
        //* CONDITION 1A: singleRecipeSelectLimit >= maxRecipeQuantity
        // - If the recipe is already selected, deselect it.
        // - Otherwise, clear existing assignments and assign the new recipe.
        if (singleRecipeSelectLimit >= maxRecipeQuantity) {
            //* If the recipe is already selected, deselect the recipe by clearing the recipe
            //* assignments and setting the current assignment quantity to 0.
            if (recipeAlreadySelected) {
                // Deselect the recipe.
                currentAssignmentQuantity = 0;
                currentMeal.RecipeAssignments = [];
            }
            else {
                // Assign the new recipe.
                currentAssignmentQuantity = Math.min(singleRecipeSelectLimit, maxRecipeQuantity);
                currentRecipeAssignment = createRecipeAssignment({
                    recipe,
                    currentAssignmentQuantity,
                    programMealId,
                    selectedDay,
                    recipeAssignment,
                });
                currentMeal.RecipeAssignments = [currentRecipeAssignment];
            }
        }
        //* CONDITION 1B: singleRecipeSelectLimit < maxRecipeQuantity
        // - If the recipe is already selected, remove it.
        // - Otherwise, append or replace a recipe selection.
        else if (singleRecipeSelectLimit < maxRecipeQuantity) {
            // Remove the recipe.
            if (recipeAlreadySelected) {
                currentAssignmentQuantity = 0;
                currentMeal.RecipeAssignments = currentMeal.RecipeAssignments.filter((assignment) => assignment.RecipeId !== recipeId);
            }
            else {
                // Calculate the total number of selected recipes.
                const totalSelectedRecipes = (_e = (_d = currentMeal.RecipeAssignments) === null || _d === void 0 ? void 0 : _d.reduce((sum, assignment) => sum + assignment.Quantity, 0)) !== null && _e !== void 0 ? _e : 0;
                if (totalSelectedRecipes < maxRecipeQuantity) {
                    // Append the new recipe.
                    currentAssignmentQuantity = Math.min(singleRecipeSelectLimit, maxRecipeQuantity - totalSelectedRecipes);
                    currentRecipeAssignment = createRecipeAssignment({
                        recipe,
                        currentAssignmentQuantity,
                        programMealId,
                        selectedDay,
                        recipeAssignment,
                    });
                    currentMeal.RecipeAssignments.push(currentRecipeAssignment);
                }
                else {
                    // Replace the first recipe selection.
                    //? Should we have a popup that asks the user if they want to replace
                    //? the first recipe selection? or do something else?
                    currentMeal.RecipeAssignments.shift();
                    // Recalculate the total selected recipes after removing the first recipe selection.
                    const totalSelectedRecipes = currentMeal.RecipeAssignments.reduce((sum, assignment) => sum + assignment.Quantity, 0);
                    currentAssignmentQuantity = Math.min(singleRecipeSelectLimit, maxRecipeQuantity - totalSelectedRecipes);
                    currentRecipeAssignment = createRecipeAssignment({
                        recipe,
                        currentAssignmentQuantity,
                        programMealId,
                        selectedDay,
                        recipeAssignment,
                    });
                    currentMeal.RecipeAssignments.push(currentRecipeAssignment);
                }
            }
        }
        // Update the cartMeals wand return.
        const updatedMeals = updateCartMeals(cartMeals, currentMeal);
        // Calculate the new total number of selected recipes.
        const newTotalSelectedRecipes = currentMeal.RecipeAssignments.reduce((sum, assignment) => sum + assignment.Quantity, 0);
        // Disable the add button if the total number of selected recipes is equal to the max recipe quantity.
        disableAddButton = newTotalSelectedRecipes >= maxRecipeQuantity;
        return {
            meals: updatedMeals,
            currentRecipeAssignment,
            recipeName,
            mealPrice,
            mealName: (_f = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.ProgramMealName) !== null && _f !== void 0 ? _f : "",
            mealDate: moment(selectedDay),
            disableAddButton,
            currentAssignmentQuantity,
            AssignmentId: currentRecipeAssignment === null || currentRecipeAssignment === void 0 ? void 0 : currentRecipeAssignment.AssignmentId,
        };
    }
    //* CASE 2: A meal exists (currentMeal is truthy) and "addMeals" is true.
    // - Add recipes to the existing meal.
    else if (!!currentMeal && addMeals) {
        // Initialize RecipeAssignments if undefined.
        currentMeal.RecipeAssignments = currentMeal.RecipeAssignments || [];
        // Check if the recipe is already selected.
        const selectedRecipe = (_g = currentMeal.RecipeAssignments) === null || _g === void 0 ? void 0 : _g.find((assignment) => assignment.RecipeId === recipeId);
        //* CONDITION 2A: Recipe is already selected.
        // - Remove the recipe and reduce the meal quantity.
        if (!!selectedRecipe) {
            const currentRecipeQty = (_h = selectedRecipe.Quantity) !== null && _h !== void 0 ? _h : 0;
            currentMeal.Quantity -= currentRecipeQty;
            currentAssignmentQuantity = 0;
            currentMeal.RecipeAssignments = (_j = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.RecipeAssignments) === null || _j === void 0 ? void 0 : _j.filter((assignment) => assignment.RecipeId !== recipeId);
        }
        //* CONDITION 2B: Recipe is not yet selected.
        // - Append the recipe and increase the meal quantity.
        else {
            currentAssignmentQuantity = singleRecipeSelectLimit;
            currentMeal.Quantity += currentAssignmentQuantity;
            currentRecipeAssignment = createRecipeAssignment({
                recipe,
                currentAssignmentQuantity,
                programMealId,
                selectedDay,
                recipeAssignment,
            });
            currentMeal.RecipeAssignments.push(currentRecipeAssignment);
        }
        // Update the cartMeals and return.
        const updatedMeals = updateCartMeals(cartMeals, currentMeal);
        return {
            meals: updatedMeals,
            currentRecipeAssignment,
            recipeName,
            mealPrice,
            mealName: (_k = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.ProgramMealName) !== null && _k !== void 0 ? _k : "",
            mealDate: moment(selectedDay),
            disableAddButton,
            currentAssignmentQuantity,
            AssignmentId: currentRecipeAssignment === null || currentRecipeAssignment === void 0 ? void 0 : currentRecipeAssignment.AssignmentId,
        };
    }
    //* CASE 3: No meal exists (currentMeal is falsy) and "addMeals" is true.
    // - Add a new meal and include the recipe.
    else if (!currentMeal && addMeals) {
        // Find the program meal for the given program meal id.
        const programMeal = program.ProgramMeals.find((pm) => pm.ProgramMealId === programMealId);
        // Update the meal price based on the program meal price.
        mealPrice = (_l = programMeal === null || programMeal === void 0 ? void 0 : programMeal.Price) !== null && _l !== void 0 ? _l : 0;
        // Get the delivery date for the selected day.
        const deliveryDate = moment((_m = modelDeliveryDays.find((dd) => moment(dd.MealDateString).isSame(moment(selectedDay), "day"))) === null || _m === void 0 ? void 0 : _m.ShipDateString);
        currentAssignmentQuantity = singleRecipeSelectLimit;
        currentRecipeAssignment = createRecipeAssignment({
            recipe,
            currentAssignmentQuantity: singleRecipeSelectLimit,
            programMealId,
            selectedDay,
            recipeAssignment,
        });
        // Create a new meal.
        const newMeal = {
            MealDate: moment(selectedDay),
            OriginalMealDate: moment(selectedDay),
            DeliveryDate: deliveryDate,
            ProgramMealId: programMealId,
            ProgramMealName: (_o = programMeal === null || programMeal === void 0 ? void 0 : programMeal.MealName) !== null && _o !== void 0 ? _o : "",
            Price: mealPrice,
            Quantity: singleRecipeSelectLimit,
            RecipeAssignments: [currentRecipeAssignment],
            NumRemovedAssignments: 0,
            MealTypeId: programMeal === null || programMeal === void 0 ? void 0 : programMeal.MealTypeId
        };
        // Update the cartMeals and return.
        const updatedMeals = [...cartMeals, newMeal];
        return {
            meals: updatedMeals,
            currentRecipeAssignment,
            recipeName,
            mealPrice,
            mealName: (_p = programMeal === null || programMeal === void 0 ? void 0 : programMeal.MealName) !== null && _p !== void 0 ? _p : "",
            mealDate: moment(selectedDay),
            disableAddButton,
            currentAssignmentQuantity,
            AssignmentId: currentRecipeAssignment === null || currentRecipeAssignment === void 0 ? void 0 : currentRecipeAssignment.AssignmentId,
        };
    }
    //* CASE 4: No meal exists (currentMeal is falsy) and "addMeals" is false.
    // - Return the initial cartMeals without changes.
    else {
        // No conditions met or the condition is (deliberately) not handled.
        // This covers the condition: !currentMeal && !addMeals
        return {
            meals: cartMeals,
            currentRecipeAssignment: undefined,
            recipeName: "",
            mealPrice: 0,
            mealName: "",
            mealDate: moment(selectedDay),
            disableAddButton: false,
            currentAssignmentQuantity: 0,
            AssignmentId: undefined,
        };
    }
};
export const handleToggleRecipeSelection = (singleRecipeSelectLimit, assignToExistingMeals, addMeals, cartMeals, recipes, program, modelDeliveryDays, sku, companyUsesKlaviyo, dispatch, createKlaviyoEvent, logReactPixel, selectedDay, dataDogLog, pixelKey) => (recipe, programMealId, setMeals, setAssignmentId, setQuantity) => __awaiter(void 0, void 0, void 0, function* () {
    const { meals, currentRecipeAssignment, mealPrice, mealName, mealDate, currentAssignmentQuantity } = toggleRecipeSelection(singleRecipeSelectLimit, assignToExistingMeals, addMeals, cartMeals, program, modelDeliveryDays, selectedDay, recipe, programMealId);
    // Set the current assignment quantity and assignment id
    // for the customize modal.
    setQuantity(currentAssignmentQuantity);
    setAssignmentId(currentRecipeAssignment === null || currentRecipeAssignment === void 0 ? void 0 : currentRecipeAssignment.AssignmentId);
    const { ingredientsToReplace } = getMustReplaceIngredients(recipe);
    // If there are ingredients to replace and the current assignment quantity is greater than 0,
    // apply the default customizations to the recipe.
    if (ingredientsToReplace && ingredientsToReplace.length > 0 && currentAssignmentQuantity > 0) {
        const { options } = getDefaultCustomizeOptions(ingredientsToReplace, recipe, currentRecipeAssignment);
        const nutrition = yield getRecipeNutrition(recipe.RecipeId, buildNutritionRequestBody(options, recipe), dataDogLog);
        // Default customizations need to be applied when the recipe quantity is incremented
        HandleCustomizeSubmit(recipes, selectedDay, dispatch)(recipe.RecipeId, programMealId, setMeals)(options, meals, undefined, currentRecipeAssignment, nutrition);
    }
    else {
        setMeals(meals);
        dispatch({ type: ActionTypes.SET_MEALS, payload: meals });
    }
    if (companyUsesKlaviyo) {
        let totalQuantity = 0;
        const mealsForKlaviyo = meals.filter((meal) => moment(meal.MealDate).isSame(moment(mealDate), "day") &&
            meal.ProgramMealId === programMealId &&
            meal.RecipeAssignments);
        mealsForKlaviyo.forEach((meal) => {
            var _a, _b, _c;
            totalQuantity +=
                (_c = (_b = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.filter((ra) => ra.RecipeId === (recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId))) === null || _b === void 0 ? void 0 : _b.reduce((accum, ra) => accum + ra.Quantity, 0)) !== null && _c !== void 0 ? _c : 0;
        });
        const eventInfo = {
            RecipeName: recipe.RecipeName,
            Quantity: totalQuantity,
            MealName: mealName,
            SKU: sku,
            DayOfWeek: moment(recipe.AvailableOn).format("ddd"),
        };
        createKlaviyoEvent("Added Recipe", eventInfo);
    }
    if (pixelKey) {
        const data = {
            content_name: recipe.RecipeName,
            content_ids: recipe.RecipeId,
            content_type: "meal",
            value: mealPrice,
            currency: "USD",
        };
        logReactPixel("AddMeal", data);
    }
});
